import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { HaccpService } from 'src/app/Services/Haccp/haccp.service';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
    HaccpActions, GetTypeProcedure,
    GetTypeRecord, GetHazardType, AddHazardType,
    CreateHazard,GetAllHazards,GetHazardById,GetHazardCount,HazardSearch,EditHazard
} from '../actions/haccp.action';


@Injectable()
export class HaccpEffects {
    constructor(private actions$: Actions,
        private store: Store<IAppState>,
        private haccpService: HaccpService
    ) { }

    getTypeProcedure$ = createEffect(() => this.actions$.pipe(
        ofType<GetTypeProcedure>(HaccpActions.GetTypeProcedure),
        map(action => action.payload),
        mergeMap((payload: any) => this.haccpService.getTypeProcedure(payload)
            .pipe(map((result: any) => ({ type: '[Haccp] Get Type Procedure Success', payload: result })),
                catchError((err) => of({ type: '[Haccp] Get Type Procedure Error', payload: err, from: 'procedureType' }))
            )
        )
    ));

    getTypeRecord$ = createEffect(() => this.actions$.pipe(

        ofType<GetTypeRecord>(HaccpActions.GetTypeRecord),
        map(action => action.payload),
        mergeMap((payload: any) => this.haccpService.getTypeRecord(payload)
        .pipe(map((result: any) => ({ type: '[Haccp] Get Type Record Success', payload: result })),
        catchError((err) => of({ type: '[Haccp] Get Type Record Error', payload: err, from: 'recordType' }))
        )
        )
    ));

    getHazardType$ = createEffect(() => this.actions$.pipe(
        ofType<GetHazardType>(HaccpActions.GetHazardType),
        map(action => action.payload),
        mergeMap((payload: any) => this.haccpService.gethazardType(payload)
            .pipe(map((result: any) => ({ type: '[Haccp] Get Hazard Type Success', payload: result })),
                catchError((err) => of({ type: '[Haccp] Get Hazard Type Error', payload: err, from: 'hazardType' }))
            )
        )
    ));

    addHazardType$ = createEffect(() => this.actions$.pipe(
        ofType<AddHazardType>(HaccpActions.AddHazardType),
        map(action => action.payload),
        mergeMap((payload: any) => this.haccpService.addHazardType(payload)
            .pipe(map((result: any) => ({ type: '[Haccp] Add Hazard Type Success', payload: result })),
                catchError((err) => of({ type: '[Haccp] Add Hazard Type Error', payload: err, from: 'addHazardType' }))
            )
        )
    ));

    createHazard$ = createEffect(() => this.actions$.pipe(
        ofType<CreateHazard>(HaccpActions.CreateHazard),
        map(action => action.payload),
        mergeMap((payload: any) => this.haccpService.addHazard(payload)
            .pipe(map((result: any) => ({ type: '[Haccp] Create Hazard Success', payload: result })),
                catchError((err) => of({ type: '[Haccp] Create Hazard Error', payload: err, from: 'createHazard' }))
            )
        )
    ));

    getAllHazards$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllHazards>(HaccpActions.GetAllHazards),
        map(action => action.payload),
        mergeMap((payload: any) => this.haccpService.getAllHazards(payload)
            .pipe(map((result: any) => ({ type: '[Haccp] Get All Hazards Success', payload: result })),
                catchError((err) => of({ type: '[Haccp] Get All Hazards Error', payload: err, from: 'getAllHazards' }))
            )
        )
    ));

    getHazardById$ = createEffect(() => this.actions$.pipe(
        ofType<GetHazardById>(HaccpActions.GetHazardById),
        map(action => action.payload),
        mergeMap((payload: any) => this.haccpService.getHazardById(payload)
            .pipe(map((result: any) => ({ type: '[Haccp] Get Hazard By Id Success', payload: result })),
                catchError((err) => of({ type: '[Haccp] Get Hazard By Id Error', payload: err, from: 'getHazardById' }))
            )
        )
    ));

    getHazardCount$ = createEffect(() => this.actions$.pipe(
        ofType<GetHazardCount>(HaccpActions.GetHazardCount),
        map(action => action.payload),
        mergeMap((payload: any) => this.haccpService.getHazardCount(payload)
            .pipe(map((result: any) => ({ type: '[Haccp] Get Hazard Count Success', payload: result })),
                catchError((err) => of({ type: '[Haccp] Get Hazard Count Error', payload: err, from: 'getHaccpCount' }))
            )
        )
    ));


    hazardSearch$ = createEffect(() =>this.actions$.pipe(
        ofType<HazardSearch>(HaccpActions.HazardSearch),
        map(action => action),
        mergeMap((action) => this.haccpService.hazardSearch(action.payload,action.title)
            .pipe(map((result: any) => ({ type: '[Haccp] Hazard Search Success', payload: result })),
                catchError((err) => of({ type: '[Haccp] Hazard Search Error', payload: err, from: 'hazardSearch' }))
            )
        )
    ));

    editHazard$ = createEffect(() =>this.actions$.pipe(
        ofType<EditHazard>(HaccpActions.EditHazard),
        map(action => action),
        mergeMap((action) => this.haccpService.editHazard(action.payload,action.param)
        .pipe(map((result: any) => ({ type: '[Hazard] Get Edit Hazard Success', payload: result})),
         catchError((err) => of({ type: '[] Get Edit Hazard Error', payload: err, from:'editHazard'}))
        )
      )
    ));

}
